import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Play from './components/Play';
import Rank from './components/Rank';
import Rule from './components/Rule';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50">
        {/* Navigation */}
        <nav className="bg-white shadow-lg">
          <div className="container mx-auto px-4">
            <div className="flex justify-center space-x-8 py-4">
              <Link 
                to="/" 
                className="text-primary hover:text-primary/80 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Play
              </Link>
              <Link 
                to="/rank" 
                className="text-primary hover:text-primary/80 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Rank
              </Link>
              <Link 
                to="/rule" 
                className="text-primary hover:text-primary/80 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Rules
              </Link>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="flex-grow container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Play />} />
            <Route path="/rank" element={<Rank />} />
            <Route path="/rule" element={<Rule />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
